(function () {
  var roots = document.querySelectorAll('[data-m1v2-compare]');
  if (!roots.length) return;

  var desktopMq = window.matchMedia('(min-width: 768px)');

  roots.forEach(function (root) {
    var grid = root.querySelector('[data-m1v2-compare-grid]');
    var thumb = root.querySelector('[data-m1v2-compare-thumb]');
    if (!grid || !thumb) return;

    function syncScrollbar() {
      if (desktopMq.matches) return;

      var pages = grid.querySelectorAll('.m1v2-compare__page');
      var pageCount = Math.max(pages.length, 1);
      var max = grid.scrollWidth - grid.clientWidth;
      var ratio = max > 0 ? grid.scrollLeft / max : 0;
      var track = thumb.parentElement;
      if (!track) return;

      var trackWidth = track.clientWidth;
      var thumbWidth = trackWidth / pageCount;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + ratio * (trackWidth - thumbWidth) + 'px)';
    }

    grid.addEventListener('scroll', syncScrollbar, { passive: true });
    window.addEventListener('resize', syncScrollbar);

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', syncScrollbar);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(syncScrollbar);
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncScrollbar).observe(grid);
    }

    syncScrollbar();
  });
})();
